import { LogoutOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const ExitBtn = ({
  icon,
  displayText = true,
  text = null,
  ...others
}) => {
  return (
    <Button
      color="danger"
      variant="outlined"
      icon={!icon ? <LogoutOutlined /> : icon}
      {...others}
    >
      {displayText && (text == null ? "Salir" : text)}
    </Button>
  );
};
